module.exports = __webpack_public_path__ + "static/img/rics-logo.66c821d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rics-logo.png
// module id = mrQm
// module chunks = 1